import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Userbanner from '../../../components/elements/Userbanner';
import baseURL, { getAsync } from '../../../components/helper/axiosHelper';
import useFetch from '../../../hooks/useFetch/useFetch';
import ServiceFYouCards from './ServiceFYouCards';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';

const ServiceForYouUPReg = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [epUserID, setEpUserID] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [countryAPIData, setCountryAPIData] = useState('');
  const [selectProjectCost, setSelectProjectCost] = useState(0);
  const [selectProjectCostFrom, setSelectProjectCostFrom] = useState(0);
  const [selectProjectCostTo, setSelectProjectCostTo] = useState(0);
  const [selectProjectType, setSelectProjectType] = useState('');
  const [countryID, setCountryID] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [datanotfound, setDatanotfound] = useState(false);

  const [dropdownOptions, setDropdownOptions] = useState({
    ProjectType: [],
    // Features: [],
    SelectCountry: [],
  });
  const [data, setData] = useState({
    countryID: 0,
    selectProjectCostFrom: 0,
    selectProjectCostTo: 0,
    //selectProjectFeature: '',
    //selectProjectFeature: '',
    ProjectTypeID: 0,
  });
  //const SDLIST = `${baseURL}/TempProject/GetTempProjectTypeList`;
  const COUNTRIES = `${baseURL}/Utilities/GetCountryList`;

  const token = localStorage.getItem('token');
  const { pathname } = useLocation();
  // Using useFetch for getsdList
  const {
    loading: sdLoading,
    error: sdError,
    value: sdData,
  } = useFetch(
    // SDLIST,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    [],
  );
  // Using useFetch for getCountries
  const { loading: countryLoading, error: countryError, value: countryData } = useFetch(COUNTRIES, {}, []);

  useEffect(() => {
    // Wait for data to be fetched and then update dropdown options
    if (!countryLoading) {
      setDropdownOptions((prev) => ({
        ...prev,
        //ProjectType: sdData?.data,
        // ProjectTypeId: sdData?.data.map((item) => item?.projectTypeID),
        // Features: sdData?.data.map((item) => item.selectProjectFeature),
        SelectCountry: countryData?.data.map((item) => item.countryName),
      }));
    }
  }, [countryData, countryLoading, sdData, sdLoading]);

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID != null) {
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const onChange = (e) => {
    const { id, value } = e.target;

    setData((prevData) => ({
      ...prevData,
      [id]: id === 'selectProjectCostFrom' || id === 'selectProjectCostTo' ? Number(value) : value,
      countryID:
        id === 'countryID'
          ? Number(countryData?.data.find((item) => item.countryName === value)?.countryID)
          : prevData.countryID,
    }));
  };

  const dynamicTitles = DynamicDropLists(dropdownOptions, countryData);

  const getData = () => {
    getAsync('APIClient/ProjectTypesSHJC').then((response) => {
      const result = response?.data;
      setApiData(result);
    });
  };

  const getCountries = async () => {
    await getAsync('APIClient/CountryListSHJC')
      .then((response) => {
        const result = response?.data;
        setCountryAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    getData();
    getCountries();
  }, []);
  const bodySearch = {
    // epUserID,
    ProjectTypeID: selectProjectType,
    // selectProjectFeature,
    CountryID: countryID,
    selectProjectCostFrom: selectProjectCostFrom,
    selectProjectCostTo: selectProjectCostTo,
  };

  const validateSearch = () => {
    let result = true;
    let errorMessage = '';

    if (+selectProjectCostFrom > 0 && +selectProjectCostTo > 0) {
      if (+selectProjectCostFrom > +selectProjectCostTo) {
        result = false;
        errorMessage += t('Cost From should be less then Cost To');
      }
    }

    // if (selectProjectType === '' || selectProjectType === null) {
    //   result = false;
    //   errorMessage += 'Please select Project Type';
    // }
    // if (selectProjectFeature === '' || selectProjectFeature === null) {
    //   result = false;
    //   errorMessage += ' Please select Project Feature\n';
    // }
    // if (countryID === '' || countryID === null) {
    //   result = false;
    //   errorMessage += ' Please Select country\n';
    // }
    // if (
    //   selectProjectCostFrom === '' ||
    //   selectProjectCostFrom === null ||
    //   selectProjectCostTo === '' ||
    //   selectProjectCostTo === null
    // ) {
    //   result = false;
    //   errorMessage += ' Please Enter Project Cost Range\n';
    // }

    if (!result) {
      toast.warning(errorMessage);
    }

    return result;
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setDatanotfound(false);
    if (validateSearch()) {
      setIsLoading(true);
      const api = `APIClient/ProjectAllSHJC?countryId=${bodySearch?.CountryID}&projectTypeId=${bodySearch.ProjectTypeID}&isPartial=true&isFixed=true&fromCost=${bodySearch.selectProjectCostTo}&toCost=${bodySearch.selectProjectCostFrom}&sortByDate=DESC`;
      await getAsync(api)
        .then((response) => {
          setIsLoading(false);
          const result = response?.data;
          console.log(result, 'results');
          if (response?.statusCode == 204) {
            setDatanotfound(true);
          }
          setSearchData(result);
          setSelectProjectCost(result[0]?.selectProjectCost);
        })
        .catch((error) => {
          toast.error(t('No project found for the requested filters.'));
        });
    }
  };

  return (
    <div className="pt-12 ">
      <Userbanner />
      <div className="container-fluid mb-4">
        <div className="row justify-center">
          <div className="col-lg-11">
            <div className="card">
              <div className="card-header py-4">
                <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">
                  {t('Service For You Registration')}
                </h1>
              </div>

              <div className="card-body ">
                {' '}
                <div className="row ">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="my-2">
                        {t('Project Type')} <span className="errmsg">*</span>
                      </label>
                      <select
                        value={selectProjectType}
                        onChange={(e) => setSelectProjectType(e.target.value)}
                        className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                      >
                        <option value="">--{t('All')}--</option>
                        {apiData?.map((item, index) => (
                          <option key={index + 1} value={item?.id}>
                            {isActive ? item?.name : item.name_EN}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            Feature <span className="errmsg">*</span>
                          </label>
                          <select
                            value={selectProjectFeature}
                            onChange={(e) => setSelectProjectFeature(e.target.value)}
                            className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen m-3 block">
                            <option value="">--SELECT--</option>
                            {apiData?.map((item, index) => (
                              <option key={index + 1} value={item?.selectProjectFeature}>
                                {item?.selectProjectFeature}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div> */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="my-2">
                        {t('Country')} <span className="errmsg">*</span>
                      </label>
                      <select
                        value={countryID}
                        onChange={(e) => setCountryID(e.target.value)}
                        className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                      >
                        <option value="00000000-0000-0000-0000-000000000000">--{t('All')}--</option>
                        {countryAPIData && countryAPIData.length > 0 ? (
                          countryAPIData?.map((item) => (
                            <option key={item?.id} value={item.id}>
                              {isActive ? item?.name_AR : item?.name_EN}
                            </option>
                          ))
                        ) : (
                          <option>{t('No country found')}</option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="my-2">
                        {t('Project Cost From')} <span className="errmsg">*</span>
                      </label>
                      <input
                        onInput={(event) => {
                          const { value } = event.target;
                          const regex = /^(\d+?)?$/;

                          if (regex.test(value) || value === '') {
                            setSelectProjectCostFrom(value);
                          } else {
                            event.target.value = value.slice(0, -1); // Revert to last valid value
                          }
                        }}
                        type="text"
                        placeholder={t('Project Cost From')}
                        className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label className="my-2">
                        {t('Project Cost To')} <span className="errmsg">*</span>
                      </label>
                      <input
                        onInput={(event) => {
                          const { value } = event.target;
                          const regex = /^(\d+?)?$/;

                          if (regex.test(value) || value === '') {
                            setSelectProjectCostTo(value);
                          } else {
                            event.target.value = value.slice(0, -1); // Revert to last valid value
                          }
                        }}
                        type="text"
                        placeholder={t('Project Cost To')}
                        className=" w-full border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                      />
                    </div>
                  </div>
                  <br />
                  {/* <br /> */}
                  <div className="col-lg-12">
                    <div className="form-group">
                      <button
                        className="text-white mt-4 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                        onClick={(e) => handleSearch(e)}
                      >
                        {t('Search')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <>
            {searchData?.length > 0 ? (
              <>
                <div className="row justify-center px-2 pt-5">
                  <ServiceFYouCards searchData={searchData} isLoading={isLoading} datanotfound={datanotfound} />
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceForYouUPReg;

function DynamicDropLists(dropdownOptions, countryData) {
  return [
    {
      title: 'ProjectType',
      Category: 'selectProjectType',
      childrens: dropdownOptions?.ProjectType.map((project) => ({
        name: project?.name,
        projectTypeID: project?.projectTypeID,
      })),
    },
    // {
    //   title: 'Feature',
    //   Category: 'selectProjectFeature',
    //   childrens: dropdownOptions?.Features.map((feature) => ({
    //     projectName: feature
    //   }))
    // },
    {
      title: 'Country',
      Category: 'countryID',
      childrens: dropdownOptions?.SelectCountry.map((country) => ({
        CountryName: country,
        countryID: countryData?.data.find((item) => item.countryName === country)?.countryID,
      })),
    },
  ];
}
